import { EDjangoAppsEndpoints } from '../enums/EDjangoAppsEndpoints';
import CoreJsonAPIService from './CoreJsonAPIService';

export class SvContactFormServices extends CoreJsonAPIService {
  static async submit(
    payload: Partial<{
      firstName: string;
      lastName: string;
      email: string;
      company: string;
      position: string;
      message: string;
    }>
  ) {
    return await super.post<any>(EDjangoAppsEndpoints.contactForm, '', payload);
  }
}
